<template>
  <div>
    <!-- <el-date-picker v-model="formTime" v-bind="datePicker" value-format="yyyy-MM-dd HH:mm:ss" /> -->
    <el-date-picker v-model="time.start" v-bind="datePicker1" value-format="yyyy-MM-dd HH:mm:ss" />
    <span>~</span>
    <el-date-picker v-model="time.end" v-bind="datePicker2" value-format="yyyy-MM-dd HH:mm:ss" />
    <el-button
      size="mini"
      type="primary"
      v-for="(btn, key) in btnsTime"
      :key="key + Date.now()"
      @click="handleTime(key)"
      round
      >{{ btn }}</el-button
    >
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'vDatePicker',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formTime: [],
      time: {
        start: '',
        end: ''
      }
    };
  },
  computed: {
    btnsTime() {
      return this.$t('orders.btns');
    }
  },
  watch: {
    'time.start'(n) {
      this.$emit('input', [n, this.time.end]);
    },
    'time.end'(n) {
      this.$emit('input', [this.time.start, n]);
    }
  },

  created() {
    this.init();
  },
  mounted() {
    this.handleTime();
  },
  methods: {
    init() {
      this.formTime = this.value;
      this.datePicker1 = {
        size: 'small',
        type: 'datetime',
        // 'value-format': 'yyyy-MM-dd HH:mm:ss',
        'range-separator': 'to',
        // @NOTE 当开始时间和结束时间默认都选同一天时，默认开时时间和结束时间选择都为00:00:00， 使用如下数字可解决
        'default-time': '00:00:00',
        'picker-options': this.banTime1()
      };
      this.datePicker2 = {
        size: 'small',
        type: 'datetime',
        // 'value-format': 'yyyy-MM-dd HH:mm:ss',
        'range-separator': 'to',
        // @NOTE 当开始时间和结束时间默认都选同一天时，默认开时时间和结束时间选择都为00:00:00， 使用如下数字可解决
        'default-time': '23:59:59',
        'picker-options': this.banTime2()
      };
    },
    timestamp(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    /* ---------------------------------- 改变时间 ---------------------------------- */
    handleTime(type = 'today') {
      const date = new Date();
      // 当天零点
      const zeroTime = new Date(date.toLocaleDateString()).getTime();
      // 当年
      const nowY = date.getFullYear();
      // 当月
      const nowM = date.getMonth();
      // 当月第一天
      const firstDayNow = new Date(nowY, nowM, 1);
      // 当月最后一天
      // const lastDayNow = new Date(nowY, nowM + 1, 0);
      // 上月第一天
      const firstDayNow1 = new Date(nowY, nowM - 1, 1);
      let start = '';
      let end = '';
      let tempDay = '';
      switch (type) {
        case 'today':
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          this.formTime = [
            this.timestamp(zeroTime),
            this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1)
          ];
          break;
        case 'yesterday':
          if (this.formTime.length > 0) {
            tempDay = new Date(new Date(this.formTime[0]).toLocaleDateString()).getTime();
            start = this.timestamp(tempDay - 60 * 60 * 24 * 1000);
            end = this.timestamp(tempDay - 1);
          } else {
            start = this.timestamp(zeroTime - 60 * 60 * 24 * 1000);
            end = this.timestamp(new Date(new Date().toLocaleDateString()).getTime() - 1);
          }
          this.formTime = [
            this.timestamp(tempDay - 60 * 60 * 24 * 1000),
            this.timestamp(tempDay - 1)
          ];
          break;
        case 'tomorrow':
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 60 * 60 * 24 * 1000);
          this.formTime = [
            this.timestamp(zeroTime),
            this.timestamp(zeroTime + 60 * 60 * 24 * 1000)
          ];
          break;
        case 'month':
          start = this.timestamp(firstDayNow);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          this.formTime = [
            this.timestamp(firstDayNow),
            this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1)
          ];
          break;
        case 'lastMonth':
          start = this.timestamp(firstDayNow1);
          end = this.timestamp(new Date(firstDayNow).getTime() - 1);

          this.formTime = [
            this.timestamp(firstDayNow1),
            this.timestamp(new Date(firstDayNow).getTime() - 1)
          ];
          break;
        default:
          break;
      }
      this.time = {
        start,
        end
      };
      this.$emit('input', [start, end]);
    },
    banTime1() {
      return {
        // disabledDate: (time) => {
        //   const zeroTime =
        //     new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
        //   // return Number(time) > Date.now() - 8.64e7;
        //   return Number(time) > zeroTime;
        // }
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      };
    },
    banTime2() {
      return {
        // disabledDate: (time) => {
        //   const zeroTime =
        //     new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
        //   // return Number(time) > Date.now() - 8.64e7;
        //   if (this.time.start) {
        //     // 限制最多选30天记录
        //     const date = new Date(this.time.start);
        //     // console.log('🚀 ~ file: v-date-picker.vue ~ line 174 ~ banTime2 ~ date', date);
        //     const Y = date.getFullYear();
        //     const M = date.getMonth();
        //     // 当月最后一天为下个月的第0天，
        //     const d = new Date(Y, M + 1, 0);
        //     const t = d.getDate();
        //     const _time = 60 * 60 * 24 * t * 1000;
        //     // Number(time) > Number(this.time.start) ||

        //     return Number(time) < Number(date) || Number(time) > zeroTime;
        //   } else {
        //     return Number(time) > zeroTime;
        //   }
        // }
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/cuscom/v-date-picker.vue